routes.$inject = ['$routeProvider'];

export default function routes($routeProvider) {
  $routeProvider
    .when('/boc', {
      template: require('./tutorial.html'),
      controller: 'TutorialCtrl',
      app: false
    });
}



// WEBPACK FOOTER //
// ./project/pages/tutorial/tutorial.routes.js